import PropTypes from "prop-types";
import { onChangePropType, labelPropType } from "../../common";

/**
 * PropTypes for Range component
 *
 * @property {number} [min] - Minimum range value
 * @property {number} [max] - Maximum range value
 * @property {number} [step] - Step increment value
 * @property {Array<number>} [values] - Array of current range values (for multi-thumb ranges)
 * @property {function} [onChange] - Change handler callback - receives new values array
 * @property {string} [label] - Label text displayed above range
 * @property {boolean} [showLabels] - Show min/max value labels
 * @property {function} [formatLabel] - Function to format label values
 */
export const rangePropTypes = {
  min: PropTypes.number,
  max: PropTypes.number,
  step: PropTypes.number,
  values: PropTypes.arrayOf(PropTypes.number),
  onChange: onChangePropType,
  label: labelPropType,
  showLabels: PropTypes.bool,
  formatLabel: PropTypes.func,
};
